import * as Yup from 'yup';
import { DRIVER_ERRORS, TAXI_ERRORS } from '../constants/ErrorMessages';
import { canDriveVehicle, isEmployed, isStudent } from '@acorn-portal/shared/src/utils';

export const driverShortSchema = Yup.object().shape({
	employmentType: Yup.string().required(DRIVER_ERRORS.employmentType),
	occupation: Yup.string().test({
		name: 'conditional-occupation',
		test: (value, context) => {
			const { employmentType } = context.parent;
			if (!employmentType || (!isEmployed(employmentType) && !isStudent(employmentType))) return true;

			if (!value) {
				if (isEmployed(employmentType)) {
					return context.createError({
						path: 'occupation',
						message: DRIVER_ERRORS.occupation,
					});
				}

				if (isStudent(employmentType)) {
					return context.createError({
						path: 'occupation',
						message: DRIVER_ERRORS.studentOccupation,
					});
				}
			}
			return true;
		},
	}),
	industry: Yup.mixed().when('employmentType', {
		is: isEmployed,
		then: () => Yup.string().required(DRIVER_ERRORS.industry),
		otherwise: (schema) => schema.notRequired(),
	}),
	employmentStatus: Yup.string().required(DRIVER_ERRORS.otherEmploymentStatus),
	otherEmployment: Yup.string().required(DRIVER_ERRORS.otherEmployment),
	otherOccupation: Yup.string().test({
		name: 'conditional-other-occupation',
		test: (value, context) => {
			const { otherEmployment, otherEmploymentType } = context.parent;
			if (otherEmployment !== 'yes' || (!isEmployed(otherEmploymentType) && !isStudent(otherEmploymentType))) {
				return true;
			}

			if (!value) {
				if (isEmployed(otherEmploymentType)) {
					return context.createError({
						path: 'otherOccupation',
						message: DRIVER_ERRORS.otherOccupation,
					});
				}

				if (isStudent(otherEmploymentType)) {
					return context.createError({
						path: 'otherOccupation',
						message: DRIVER_ERRORS.studentOccupation,
					});
				}
			}
			return true;
		},
	}),
	otherEmploymentType: Yup.mixed().when('otherEmployment', {
		is: 'yes',
		then: () => Yup.string().required(DRIVER_ERRORS.otherEmploymentType),
		otherwise: (schema) => schema.notRequired(),
	}),
	otherEmploymentStatus: Yup.string().when('otherEmployment', {
		is: 'yes',
		then: () => Yup.string().required(DRIVER_ERRORS.otherEmploymentStatus),
		otherwise: (schema) => schema.notRequired(),
	}),
	otherIndustry: Yup.mixed().when(['otherEmployment', 'otherEmploymentType'], {
		is: (otherEmployment: string, otherEmploymentType: string) =>
			otherEmployment === 'yes' && isEmployed(otherEmploymentType),
		then: () => Yup.string().required(DRIVER_ERRORS.otherIndustry),
		otherwise: (schema) => schema.notRequired(),
	}),
});

export const taxiDriverShortSchema = (vehicleUsage: string) =>
	driverShortSchema.shape({
		driverUsage: Yup.string()
			.required(DRIVER_ERRORS.driverUsageRequired)
			.test('public-hire-vehicle', TAXI_ERRORS.publicUsage, function (value) {
				if (!canDriveVehicle(value, vehicleUsage)) {
					return false;
				}
				return true;
			}),
	});
